module.exports = __webpack_public_path__ + "img/aircon_hot_on_border.048fd2ca.png";